import * as React from 'react';
import * as main from "../../main.module.scss";
import * as screen1 from "./style.module.scss";
import { HeaderLogoAndTel } from "../../../../HeaderLogoAndTel";
import { WebDate } from "../../../../WebDate";
export const Screen1 = ({ id }) => {
  return (
    <section className={screen1.screen1}>
      <div className="container">
        <HeaderLogoAndTel/>
        <div className={screen1.container}>
          <div className={screen1.info}>
            <p className={screen1.type}>Бесплатный вебинар <time><WebDate id={id}/></time></p>
            {/*<p className={screen1.type}>Бесплатный вебинар <time>16 апреля в 19:00</time></p>*/}
            <h1>Гаджет–зависимость</h1>
            <ul>
              <li>Устали от того, что ваше чадо всё свободное время проводит в телефоне/планшете/компьютере?</li>
              <li>Дети не хотят ничего кроме, как зависать в гаджете?</li>
              <li>Мультики, компьютерные игры, соц.сети заменили ребёнку реальную жизнь?</li>
            </ul>
            <p className={screen1.get}>На вебинаре вы получите алгоритм вывода ребенка из гаджет-зависимости, а также непосредственно на вебинаре вы попробуете на практике подкрепить интерес ребенка к учебе!</p>
            <a className={main.btn} href={"#reg"}>Зарегистрироваться</a>
          </div>
        </div>
      </div>
    </section>
  );
};
